/**
 * Configuration the CMS block passes in through data attributes on the mount point. Data
 * attributes instead of globals, so a second instance would not overwrite the first.
 */
export type AppConfig = {
  title: string
  intro: string
}

export function readConfig(mount: HTMLElement): AppConfig {
  return {
    title: mount.dataset.title ?? '',
    intro: mount.dataset.intro ?? '',
  }
}
